import { MdCheckCircle, MdCancel, MdOutlineError } from 'react-icons/md';
import ComplexTable from 'components/table';
import { createColumnHelper } from '@tanstack/react-table';
import { Link } from 'react-router-dom';
import Button from 'components/button';
import { HiArrowRight } from 'react-icons/hi';
import UseApi from 'hooks/useApi';
import { IFilter } from 'types';
import { encodeFilters } from 'utils';

type RowObj = {
  _id: string;
  amount: number;
  state: 'pending' | 'successful' | 'unsuccessful';
  createdAt: string;
  user: { _id: string; username: string; email: string };
};

const columnHelper = createColumnHelper<RowObj>();
const columns = [
  columnHelper.accessor('user', {
    id: 'user',
    header: () => <p className="  ">USER</p>,
    cell: (info) => (
      <Link target="#" to={`/admin/user/${info.getValue()?._id}`}>
        <p className="  ">
          {info.getValue()?.username || info.getValue()?.email}
        </p>
      </Link>
    ),
  }),
  columnHelper.accessor('amount', {
    id: 'amount',
    header: () => <p className="  ">AMOUNT (PKR)</p>,
    cell: (info) => <p className="  ">{info.getValue()}</p>,
  }),

  columnHelper.accessor('createdAt', {
    id: 'date',
    header: () => <p className="  ">DATE</p>,
    cell: (info) => <p className="  ">{info.getValue().substring(0, 10)}</p>,
  }),

  columnHelper.accessor('state', {
    id: 'state',
    header: () => <p className="  ">STATUS</p>,
    cell: (info) => (
      <div className="flex items-center">
        {info.getValue() === 'successful' ? (
          <MdCheckCircle className="me-1 text-green-500 dark:text-green-300" />
        ) : info.getValue() === 'unsuccessful' ? (
          <MdCancel className="me-1 text-red-500 dark:text-red-300" />
        ) : info.getValue() === 'pending' ? (
          <MdOutlineError className="me-1 text-amber-500 dark:text-amber-300" />
        ) : null}
        <p className="text-sm font-bold text-navy-700 dark:text-white">
          {info.getValue()}
        </p>
      </div>
    ),
  }),
  columnHelper.accessor('_id', {
    id: '_id',
    header: () => <p className="  ">DETAILS</p>,
    cell: (info) => (
      <Link key={1} to={info.getValue()}>
        <Button type="icon">
          <HiArrowRight />
        </Button>
      </Link>
    ),
  }),
];

const filters: IFilter[] = [
  { key: 'user', type: 'text', label: 'User' },
  { key: 'createdAtFrom', type: 'date', label: 'From Date' },
  { key: 'createdAtTo', type: 'date', label: 'To Date' },
  {
    key: 'state',
    type: 'select',
    options: ['pending', 'successful', 'unsuccessful'],
    label: 'Status',
  },
  {
    key: 'showArchived',
    type: 'select',
    options: ['false', 'true'],
    label: 'Archived',
  },
];

const WithdrawalRequests = () => {
  const { getApi } = UseApi();

  async function fetchData(
    options: any,
    filtersState: { [key: string]: string },
  ) {
    const { pageIndex, pageSize } = options;
    const response = await getApi(
      `withdrawalRequests?page=${
        pageIndex + 1
      }&limit=${pageSize}${encodeFilters(filtersState)}`,
    );
    const data = response.data.data.withdrawalRequests;
    const pageCount = response.data.data.totalPages;
    return {
      rows: data,
      pageCount,
    };
  }
  return (
    <div>
      <ComplexTable columns={columns} fetchData={fetchData} filters={filters} />
    </div>
  );
};
export default WithdrawalRequests;
